import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Components/Header";
import Homepage from "./Components/Homepage";
import Royaltiespage from "./Components/Royaltiespage";
import NftViewerpage from "./Components/NftViewerpage";
import Footer from "./Components/Footer";
import { Provider } from "react-redux"
import store from "./Resource/store"
import TeamView from "./Components/TeamView";

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Header />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <>
                <Homepage />
              </>
            }
          ></Route>
          <Route path="/royalties" element={<Royaltiespage />} />
          <Route path="/nftviewer" element={<NftViewerpage />} />
          <Route path="/team" element={<TeamView />} />
        </Routes>
        <Footer />
      </Router>
    </Provider>
  );
}

export default App;
